import React from 'react';
import {TableRowColumn} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import FontIcon from "material-ui/FontIcon";
import {Tooltip} from 'react-tippy';

const BookCell = ({inventoryType, rateType, showRate, bookable}) => {
  let styles = {
    customRowStyle : {
      paddingRight: 5,
      paddingLeft: 5,
    },
    customButtonStyle: {
      width: 30,
      height: 24
    },
    customLabelStyle: {
      paddingRight: 0,
      paddingLeft: 0,
    },
    iconStyle: {
      fontSize: 24
    }
  };
  return (
      <TableRowColumn style={styles.customRowStyle} className="book" >
        {bookable && <RaisedButton href={inventoryType.url}
                      className="bookBtn"
                      target="_blank"
                      style={styles.customButtonStyle}
                      labelStyle={styles.customLabelStyle}
                      label="Book"
                      fullWidth={true}
                      primary={true} />}
          {showRate && !bookable && <Tooltip trigger="mouseenter"
                                          size='small'
                                          arrow={true}
                                          theme='dark'
                                          position='right'
                                          interactive
                                          html={
                                            rateType === 'P' ?
                                                <p>Rate displayed is for 2 people</p> :
                                                <p>Rate displayed is for 1 room</p>}
        >
          <div className="rateTypeIcon">
            {rateType === 'P' ? <FontIcon style={styles.iconStyle}
                                          className="material-icons">people</FontIcon>
                : <FontIcon style={styles.iconStyle}
                            className="material-icons">hotel</FontIcon>}
          </div>
        </Tooltip> }
        {!showRate
        && !bookable
        && <FontIcon style={styles.iconStyle}
                                 className="material-icons">hotel</FontIcon> }
      </TableRowColumn>
  )
};

export default BookCell;


// WEBPACK FOOTER //
// ./src/components/BookCell.js